
import LogisticsTypeList from './list.vue'
import LogisticsTypeEdit from "./edit.vue";

let a = Object.assign({LogisticsTypeList,LogisticsTypeEdit});
export default a;